import { Suspense } from 'react'
import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import { TrainingClassDetailIndexPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { SessionsDataTable } from './SessionsDatatable'

const SessionsTab = () => {
  const { classId, id } = useParams()
  const { canEdit } = useOutletContext<{ canEdit: boolean }>()
  const { company } = useCurrentSession()
  const { data } = useQuery(TrainingClassDetailIndexPageDocument, {
    variables: { companyId: company.id, trainingClassId: String(classId), withFF: true },
  })

  const currentClass = data?.trainings.trainingClass ?? undefined
  const sessionCount = currentClass?.sessionsConnection.totalCount ?? 0
  return (
    <>
      <SessionsDataTable trainingClassId={String(classId)} trainingId={String(id)} />
      <Suspense fallback={null}>
        <Outlet
          context={{
            canEdit,
            currentClass,
            id,
            classId,
            trainingId: currentClass?.training?.id ? String(currentClass.training.id) : id,
            classStartDate: currentClass?.startDate,
            classEndDate: currentClass?.endDate,
            sessionCount,
          }}
        />
      </Suspense>
    </>
  )
}

export default SessionsTab
